import FormController from "../util/FormController.js";
var RefreshAuthStateController = FormController.extend({
  className: "refresh-auth-state",
  Model: {},
  Form: {
    noButtonBar: true
  },
  preRender: function() {
    const appState = this.options.appState;
    const token = this.options.token;
    this.model.startTransaction(function(authClient) {
      appState.trigger("loading", true);
      if (token) {
        return authClient.tx.introspect({
          stateToken: token
        });
      }
      if (authClient.tx.exists()) {
        return authClient.tx.resume();
      }
      appState.trigger("navigate", "");
    });
  },
  remove: function() {
    this.options.appState.trigger("loading", false);
    return FormController.prototype.remove.apply(this, arguments);
  }
});
export { RefreshAuthStateController as default };
